import { render, staticRenderFns } from "./CustomerNav.vue?vue&type=template&id=463975d3"
import script from "./CustomerNav.vue?vue&type=script&lang=js"
export * from "./CustomerNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports